import { render, staticRenderFns } from "./PriorityLegend.vue?vue&type=template&id=885ed28c&scoped=true"
import script from "./PriorityLegend.vue?vue&type=script&lang=js"
export * from "./PriorityLegend.vue?vue&type=script&lang=js"
import style0 from "./PriorityLegend.vue?vue&type=style&index=0&id=885ed28c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885ed28c",
  null
  
)

export default component.exports